import { ReactNode } from 'react';

import { makeAuditRoute as _makeAuditRoute } from '@gasbi/shared/web/Audit';

import {
  useGetAuditEntriesInfiniteQuery,
  useGetAuditEntryDetailsQuery,
} from '@/features/audit/auditApi';
import { AuditEntityTypeName } from '@/features/audit/types';

import { UserPermissionType } from '@components/Permissions/types';

import { useGetEntityTypeName } from './hooks';

const auditHooks = {
  useGetAuditEntryDetailsQuery,
  useGetAuditEntriesInfiniteQuery,
  useGetEntityTypeName,
};

export const makeAuditRoute = (
  path: string | (() => string),
  element: ReactNode,
  permissions: UserPermissionType | UserPermissionType[] = [],
) => _makeAuditRoute(path, element, permissions, auditHooks);

export const auditLinkTemplates = {
  [AuditEntityTypeName.CommercialMeteringPointEntity]: '..', // same as '../../ID'
  [AuditEntityTypeName.CommercialMeteringPointOwnershipEntity]:
    '../ownership-history/ID',
  [AuditEntityTypeName.GasPipelineSectionEntity]: '../gas-pipelines',
  [AuditEntityTypeName.ActBalanceOwnershipEntity]:
    '../documents/act-balance-ownership/ID',
  [AuditEntityTypeName.ViolationActEntity]: '../violation-acts/ID',
  [AuditEntityTypeName.MeteringPointActEntity]: '../metering-point-acts/ID',
  [AuditEntityTypeName.GasConsumingEquipmentEntity]: '../equipment/ID',
  [AuditEntityTypeName.MeteringDeviceEntity]: '../devices/ID',
  [AuditEntityTypeName.ModemEntity]: '../devices/modems/ID',
  [AuditEntityTypeName.SealEntity]: '../seals/ID',
  [AuditEntityTypeName.SectorBridgeActEntity]: '../bridge-acts/ID',
};
